import * as React from 'react';
import { IgcListHeaderComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Header list item.
 * @slot  - Renders header list item's content.
 * @class
 */
export const IgrListHeader = /* @__PURE__ */ createComponent({
  tagName: 'igc-list-header',
  displayName: 'IgrListHeader',
  elementClass: Component,
  react: React,
});

export type IgrListHeader = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrListHeaderModule = Component;
